// Text style presets for affiliate app blog elements
const textStylePresets = {
  heading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  heading2: {
    fontFamily: "'Playfair Display Bold', Georgia, 'Times New Roman', serif",
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '1.2',
    letterSpacing: '-0.02em',
    color: '#101022',
    textAlign: 'left',
  },
  subheading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  subheading2: {
    fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '1.4',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  paragraph1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '1.6',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
  },

};

// Frame presets for images and videos
const framePresets = {
  square: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '1/1',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  landscape: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '16/9',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  portrait: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '9/16',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  portrait45: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '4/5',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
};

// Button style presets
const buttonStylePresets = {
  buttonStandard: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0.09px',
    backgroundColor: '#38C558',
    color: '#ffffff',
    textAlign: 'center',
    textTransform: 'none',
    width: '100%',
    borderRadius: '0px',
    padding: '12px 24px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
  },
  buttonRounded: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0.09px',
    backgroundColor: '#ff6b35',
    color: '#ffffff',
    textAlign: 'center',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '12px 24px',
    width: '100%',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
  },
  button3D: {
    backgroundColor: '#f5003c',
    color: '#fff',
    borderRadius: '16px',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: '0 8px 0 #a8002c, 0 8px 16px rgba(0,0,0,0.15)',
    padding: '18px 0',
    width: '100%',
    border: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s cubic-bezier(.25,.8,.25,1)',
    display: 'block',
    textDecoration: 'none',
  },
  buttonGradient: {
    background: 'linear-gradient(180deg, #ffe066 0%, #ffb347 100%)',
    color: '#222',
    borderRadius: '12px',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '20px 0',
    width: '100%',
    border: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s cubic-bezier(.25,.8,.25,1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '18px',
    textDecoration: 'none',
  },
};

// Helper functions
export const getPresetNames = () => Object.keys(textStylePresets);
export const getPreset = (presetName) => textStylePresets[presetName] || textStylePresets.paragraph1;
export const getFramePresetNames = () => Object.keys(framePresets);
export const getFramePreset = (presetName) => framePresets[presetName] || framePresets.square;
export const getButtonPresetNames = () => Object.keys(buttonStylePresets);
export const getButtonPreset = (presetName) => buttonStylePresets[presetName];
export const getPresetFontFamilies = () => {
  const allPresets = {
    ...textStylePresets,
    ...buttonStylePresets
  };
  const fontFamilies = new Set();
  Object.values(allPresets).forEach(preset => {
    if (preset.fontFamily) {
      fontFamilies.add(preset.fontFamily);
    }
  });
  return Array.from(fontFamilies).sort();
};

export default textStylePresets;
